import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e091f282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "text-white" }

import { ref, onMounted, computed, withDefaults } from 'vue';
import { AtomSelect, AtomButton, AtomInput } from '@/components/atoms';
import { MoleculeCard } from '.'
import { Brand } from '@/core/model';
import { getPaginate } from '@/core/service/BrandsService'
import { getPaginate as getCostCenterPaginate } from '@/core/service/CostCentersService'
import { IOptionsSelect } from '@/types';
import Swal from 'sweetalert2';

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
import { CostCenter } from '@/core/model/CostCenter';
type Source = "resale" | "brand" | "warehouse" | "trigger" | "user" | "season" | "cost_center";

interface PageData {
  source: Source
  page: number,
  enableToLoad: boolean
}

interface IProps {
  hasClient: boolean;
  hasResale: boolean;
  hasCostCenter: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGradesFilter',
  props: {
    hasClient: { type: Boolean, default: true },
    hasResale: { type: Boolean, default: false },
    hasCostCenter: { type: Boolean, default: true }
  },
  emits: ["handleFilter", "handleClear"],
  setup(__props: any, { emit: __emit }) {

// import { defineProps } from 'vue';
let locale: string = messages[getLanguage()]['message'];

const brands = ref<Brand[]>([]);
const costcenters = ref<CostCenter[]>([]);
const filters = ref<any>({});
const props = __props;
const pagination = ref<PageData[]>([
  {
    source: 'brand',
    page: 1,
    enableToLoad: true
  },
  {
    source: 'cost_center',
    page: 1,
    enableToLoad: true
  }
]);
const emit = __emit
const brandsComputed = computed(() => {
  return brands.value?.map(x => {
    return { text: x.name, value: x.id } as IOptionsSelect
  })
})

function loadBrands() {
  const brands_page = pagination.value.find((p) => p.source === "brand");
  getPaginate(brands_page?.page ?? 1)
    .then((resp) => {
      if (brands_page) brands_page.enableToLoad = resp.data.length ?? false;

      brands.value?.push(...resp.data ?? []);
    });
}

const costcentersComputed = computed(() => {
  return costcenters.value?.map(x => {
    return { text: `${x.sap_cost_center_code} - ${x.name}`, value: x.id } as IOptionsSelect
  })
})

function loadCostCenters() {
  const cost_center_page = pagination.value.find((p) => p.source === "cost_center");
  getCostCenterPaginate(cost_center_page?.page ?? 1)
    .then((resp) => {
      if (cost_center_page) cost_center_page.enableToLoad = resp.data.length ?? false;
      costcenters.value?.push(...resp.data ?? []);
    });
}

function nextPagination(source: Source, cb: any) {
  const index = pagination.value.findIndex((p) => p.source === source);

  pagination.value[index].page++;

  cb();
}

function handleFilter() {
  const filter = JSON.parse(JSON.stringify(filters.value));
  if (filter.brand_id)
    filter.brand_id = filter.brand_id.join(',')

  if (filter.cost_center_id)
    filter.cost_center_id = filter.cost_center_id.join(',')

  if (!filter.start_date && filter.end_date) {
    Swal.fire({
      icon: "warning",
      title: locale['common']['atention'],
      text: locale['invoices']['select_date'],
    })
    return
  }

  if (filter.start_date && !filter.end_date) {
    Swal.fire({
      icon: "warning",
      title: locale['common']['atention'],
      text: locale['invoices']['select_date'],
    })
    return
  }

  emit("handleFilter", filter);
}
onMounted(() => {
  loadBrands();
  loadCostCenters();
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), { class: "width-card w-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('message.invoices.note_filter')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('message.invoices.refine_notes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: _ctx.$t('message.invoices.note_number'),
                    placeholder: _ctx.$t('message.invoices.note'),
                    modelValue: filters.value.invoice,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.invoice) = $event))
                  }, null, 8, ["label", "placeholder", "modelValue"])
                ]),
                _: 1
              }),
              (props.hasClient)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomInput), {
                        label: _ctx.$t('message.invoices.customer_name'),
                        placeholder: _ctx.$t('message.invoices.customer'),
                        modelValue: filters.value.client,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.client) = $event))
                      }, null, 8, ["label", "placeholder", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.hasClient)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomSelect), {
                        multiple: true,
                        options: costcentersComputed.value,
                        label: _ctx.$t('message.common.cost_center') + ':',
                        placeholder: _ctx.$t('message.common.cost_center') + '...',
                        enableLoad: pagination.value.find((p) => p.source === 'cost_center')?.enableToLoad ?? false,
                        onLoad: () => { nextPagination('cost_center', loadCostCenters) },
                        modelValue: filters.value.cost_center_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.cost_center_id) = $event))
                      }, null, 8, ["options", "label", "placeholder", "enableLoad", "onLoad", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomSelect), {
                    multiple: true,
                    options: brandsComputed.value,
                    label: _ctx.$t('message.common.brand') + ':',
                    placeholder: _ctx.$t('message.common.brand') + '...',
                    enableLoad: pagination.value.find((p) => p.source === 'brand')?.enableToLoad ?? false,
                    onLoad: () => { nextPagination('brand', loadBrands) },
                    modelValue: filters.value.brand_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.brand_id) = $event))
                  }, null, 8, ["options", "label", "placeholder", "enableLoad", "onLoad", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: _ctx.$t('message.common.from'),
                    placeholder: _ctx.$t('message.common.from_elipssis'),
                    modelValue: filters.value.start_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.start_date) = $event)),
                    type: "date"
                  }, null, 8, ["label", "placeholder", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    label: _ctx.$t('message.common.to'),
                    placeholder: _ctx.$t('message.common.to_elipssis'),
                    modelValue: filters.value.end_date,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.end_date) = $event)),
                    type: "date"
                  }, null, 8, ["label", "placeholder", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "my-3" }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {filters.value = {}; emit('handleClear', undefined);})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.common.clear')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    class: "text-bold w-100 text-sm pa-1 my-1 btn-submit",
                    onClick: handleFilter
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('message.common.apply')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})